import transformStyle from 'bidi-css-js';
export default function bidi() {
  var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'ltr';
  return function bidiPlugin(style, type, renderer, props) {
    var _props$theme;

    return transformStyle(style, (props === null || props === void 0 ? void 0 : (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.direction) || direction);
  };
}